(function () {
    'use strict';

    angular
        .module('adminReferenceDataControllers', ['services.authenticatedUser']);
})();
